import { render, staticRenderFns } from "./BlogCategoryModalForm.vue?vue&type=template&id=93108ca2"
import script from "./BlogCategoryModalForm.vue?vue&type=script&lang=js"
export * from "./BlogCategoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports